<template>
  <div class="personal" v-r-loading="loading">
    <div class="content margin-top-8">
      <p>{{ $t('名字') }}</p>
      <el-input
        :class="isH5 ? 'el-input_d-reset_h5_in' : 'el-input_d-reset'"
        v-model="form.firstName"
        :placeholder="$t('请输入名字')"
        :maxLength="30"
        clearable
      ></el-input>
    </div>
    <div class="content margin-top">
      <p>{{ $t('姓氏') }}</p>
      <el-input
        :class="
          isH5
            ? 'el-input_d-reset_h5_in el-input-h5-bottom'
            : 'el-input_d-reset'
        "
        v-model="form.lastName"
        :placeholder="$t('请输入姓氏')"
        :maxLength="30"
        clearable
      ></el-input>
    </div>
    <div class="content margin-top" :class="isH5 ? 'phone-h5' : ''">
      <p>{{ $t('电话') }}</p>
      <el-input
        :value="phone | changePhone"
        :placeholder="$t('请输入电话号码')"
        disabled
        class="input-phone"
      ></el-input>
    </div>
    <DownloadApp class="down-load-h5" />
    <!-- bottom -->
    <el-button class="btn" @click="submit" :disabled="disabled">{{
      $t('确定')
    }}</el-button>
  </div>
</template>

<script>
import DownloadApp from '@/components/DownloadApp';
import { mapState, mapActions } from 'vuex';
export default {
  components: {
    DownloadApp,
  },
  data() {
    return {
      form: {
        firstName: '',
        lastName: '',
      },
      disabled: true,
    };
  },
  computed: {
    ...mapState({
      isH5: ({ common }) => common.isH5,
      userInfo: ({ user }) => user.userInfo,
      sidebar: ({ common }) => common.sidebar,
      phone: ({ common }) => common.sidebar?.selfInfo?.phone,
      loading: ({ user }) => user.loading,
    }),
  },
  watch: {
    form: {
      handler: function (val) {
        if (val?.firstName || val?.lastName) {
          this.disabled = false;
        } else {
          this.disabled = true;
        }
      },
      deep: true,
    },
  },
  filters: {
    changePhone(value) {
      var len = value.length;
      var x = value.substring(4, len - 3);
      var values = value.replace(x, '****');
      return values;
    },
  },
  mounted() {
    this.form.firstName = this.sidebar?.selfInfo?.firstName;
    this.form.lastName = this.sidebar?.selfInfo?.lastName;
  },
  methods: {
    ...mapActions('user', ['updateUserInfo']),
    ...mapActions('common', ['getSidebar']),

    async submit() {
      try {
        await this.updateUserInfo({
          firstName: this.form.firstName,
          lastName: this.form.lastName,
        });
        await this.getSidebar();
        this.$message.success(
          this.$t('FoodC_sidebar_Update_successfully_cuyI')
        );
        this.$emit('close');
      } catch (error) {
        this.$utils.errorToast(error);
      }

      this.$trackEvent({
        eventId: 'sailing_c_x_profile_confirm_ck',
        eventLabel: '个人页面确认按钮点击',
        attrs: {
          action_type: 2,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.margin-top {
  margin-top: 28px;
}
.margin-top-8 {
  margin-top: 24px;
}
.personal {
  position: relative;
  min-height: 556px;
  max-width: 768px;
  margin: 0 auto;
  color: #000;
  .content {
    margin-bottom: 20px;
    > p {
      font-family: 'Aspira Medium';
      font-weight: 500;
      font-size: 14px;
      padding-bottom: 12px;
    }
  }
  .btn {
    position: absolute;
    bottom: 20px;
    right: 0;
    min-width: 140px;
  }
}
.down-load {
  margin-bottom: 10px;
}
@media screen and (max-width: 768px) {
  .margin-top-8 {
    margin-top: rem(20);
  }
  .margin-top {
    margin-top: 0;
  }
  .phone-h5 {
    margin-top: rem(24);
    display: flex;
    > p {
      flex: 1;
    }
    .input-phone {
      width: unset;
    }
  }
  .personal {
    position: relative;
    min-height: rem(880);
    max-width: 100%;
    margin: 0 auto;
    .content {
      background: #fff;
      margin-bottom: 0px;
      padding: rem(24) rem(24) 0 rem(24);
      > p {
        font-family: 'Aspira Medium';
        color: #999;
        font-size: rem(24);
        padding-bottom: 0;
        position: relative;
        top: rem(8);
      }
      .el-input__inner {
        border: none;
      }
    }
    .phone-h5 {
      padding: 0 rem(24);
      line-height: rem(120);
      > p {
        color: #000;
        top: 0;
      }
    }
    .btn {
      position: fixed;
      width: rem(702);
      bottom: rem(60);
      right: rem(24);
      height: rem(90);
    }
    .down-load-h5 {
      margin: rem(27) 0 rem(27) rem(24);
    }
  }
}
</style>
<style lang="scss">
.personal .el-input.is-disabled .el-input__inner {
  background-color: #cfcfcf;
  color: #f8f8f8;
}
.input-phone {
  .el-input__inner {
    border: none;
  }
}
@media screen and (max-width: 768px) {
  .personal {
    .content {
      .el-input__inner {
      }
    }
  }
  .el-input-h5-bottom {
    .el-input__inner {
      border-bottom: 1px solid #fff;
      padding-bottom: 4px;
    }
  }
  .personal .el-input.is-disabled .el-input__inner {
    background-color: #fff;
    font-size: rem(32);
    color: #888;
    text-align: right;
    opacity: 1;
  }
}
</style>
